import { PricingFunction } from './types';

export const pricePerRun: PricingFunction = options => {
  const { dayRate, rateRecord } = options;
  return dayRate || rateRecord.rate_0;
};
